import { render, staticRenderFns } from "./PageIcon.vue?vue&type=template&id=df384e6a"
import script from "./PageIcon.vue?vue&type=script&lang=js"
export * from "./PageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports